import { competitionListTimeEnum } from "app/utils/const";
import { Component } from "react";
import "react-dropdown/style.css";
import type { IntlShape } from "react-intl";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import {
  IconBookmark,
  IconFavorite,
} from "../../../../../../components/Icon/Icon";
import GetSportsIcon from "../../helpers/GetSportsIcon/GetSportsIcon";
type Props = {
  bookmarksOnly: boolean;
  favouritesOnly: boolean;
  translatedSportName: string;
  selectedSportName: string;
  selectedSportTimeFrame: string;
  intl: IntlShape;
};

class CompetitionListTitle extends Component<Props> {
  // return string formatted as SPORTNAME - LIVE/EARLY/TODAY
  getSportNameAndTimeForDisplay(): string {
    const { translatedSportName, selectedSportTimeFrame, intl } = this.props;
    const selectedSportTimeFrameIntlId =
      selectedSportTimeFrame &&
      selectedSportTimeFrame !== competitionListTimeEnum.ALL &&
      selectedSportTimeFrame.length > 0
        ? `events-${selectedSportTimeFrame.toLowerCase()}`
        : "";

    if (selectedSportTimeFrameIntlId && selectedSportTimeFrameIntlId !== "") {
      const I18n = defineMessages({
        selectedSportTimeFrameIntlId: {
          id: selectedSportTimeFrameIntlId,
        },
      });
      return `${translatedSportName} - ${intl.formatMessage(
        I18n.selectedSportTimeFrameIntlId
      )}`;
    } else {
      return `${translatedSportName}`;
    }
  }

  render() {
    const { bookmarksOnly, favouritesOnly, selectedSportName } = this.props;
    return (
      <div className="asian-global-events-navigation">
        {favouritesOnly && (
          <span className="sport bookmark-selected">
            <IconFavorite />
            <FormattedMessage tagName="span" id="events-favorites" />
          </span>
        )}
        {bookmarksOnly && (
          <span className="sport bookmark-selected">
            <IconBookmark />
            <FormattedMessage tagName="span" id="events-bookmarks" />
          </span>
        )}
        {!(favouritesOnly || bookmarksOnly) && (
          <span className="sport">
            {<GetSportsIcon intl={this.props} sportName={selectedSportName} />}
            {this.getSportNameAndTimeForDisplay()}
          </span>
        )}
      </div>
    );
  }
}

export default injectIntl(CompetitionListTitle) as any;
